import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "navbar": {
        "home": "Home",
        "me": "Me",
        "about": "About Me",
        "equipment": "My Station",
        "contact": "Contact",
        "blog": "Blog",
        "map": "QSO Map",
        "calculators": "Calculators"
      },
      "about": {
        "title": "About Me",
        "bio1": "Hello! I'm Oguz AGCELI. My interest in electronics and radio communication started years ago. Thanks to my father, my childhood was spent with radios and electronic circuits. Although my job is software and electronics, I always postponed getting a license (procrastination is bad :)).",
        "bio2": "I actively operate on HF, VHF, and UHF bands. I enjoy experimenting with antennas, using digital modes, and building my own equipment.",
        "bio3": "I am also the Ankara representative of the ARC Amateur Radio Operators Association. Under our club callsign (YM2KTR), I have set up / am operating 1 DMR wide-area hotspot, 2 LoRa i-Gates, and 1 AFSK (VHF) APRS station.",
        "certificatesTitle": "Certificates & Awards",
        "cert1": "Amateur Radio License Class A",
        "cert2": "Community Service Award"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Amateur Radio Station",
        "description": "Personal amateur radio station of TA2GBO (Oguz AGCELI). Explore HF/VHF/UHF activities, antenna projects, online logbook, QSL card generator, and amateur radio calculators (Dipole, EFHW, GP).",
        "keywords": "TA2GBO, Oguz AGCELI, amateur radio, ham radio, hf, vhf, uhf, antenna projects, electronics, qso logbook, qsl card, dmr, aprs, lora, efhw calculator, dipole calculator, coax loss"
      },
      "home": {
        "welcome": "Hello",
        "subtitle": "Welcome to the World of Amateur Radio",
        "logbookBtn": "Check Logbook",
        "contentTitle": "73!",
        "contentBody1": "With the call sign TA2GBO; I actively work on HF bands in SSB and digital modes, and develop applications on VHF/UHF communication systems. In addition to classic amateur radio work, I work on experimental devices and projects using LoRa modulation.",
        "contentBody2": "I adopt an approach that combines theory with practice by designing and manufacturing my own antennas for HF and VHF/UHF bands as much as possible. This site is a personal archive where carried out works, technical notes, and field experiences are shared.",
        "conditions": "Band Conditions",
        "onAirStatus": "Current Status",
        "offAir": "OFF AIR",
        "statsTitle": "Logbook Stats",
        "statTotal": "Total QSOs",
        "statYear": "This Year",
        "statToday": "Today",
        "statMonth": "This Month",
        "qslSearchTitle": "Did we have a QSO before? If so, get your Digital QSL Card now!",
        "callsignPlaceholder": "Enter Callsign",
        "searchBtn": "Search",
        "qslSearchNoResult": "Sorry, we haven't had a QSO.",
        "qslSearchResults": "QSOs Found:",
        "downloadQsl": "Download QSL Card",
        "qslPreview": "QSL Card Preview",
        "close": "Close",
        "lastQSOs": "Last 10 QSOs",
        "date": "Date",
        "time": "Time",
        "callsign": "Callsign",
        "band": "Band",
        "grid": "Grid",
        "mode": "Mode",
        "rst": "RST"
      },
      "contact": {
        "title": "Contact",
        "email": "E-mail",
        "instagram": "Instagram",
        "qrz": "QRZ.com Profile",
        "grid": "Grid Locator",
        "youtube": "YouTube"
      },
      "station": {
        "radios": "Transceivers",
        "antennas": "Antennas",
        "accessories": "Accessories & Other Gear",
        "desc_ft710": "My main HF transceiver. I generally use it for digital modes and SSB contacts.",
        "desc_ft891": "My second / field radio. I use it in activities or in my car.",
        "desc_d878uv": "Handheld radio I use for DMR and analog local communications.",
        "desc_uvk6": "For field work and backup use.",
        "desc_atas120a": "For mobile operations in my car or in the field.",
        "desc_efhw": "Self-made wire antenna working on bands between 40m-10m.",
        "desc_vx50": "My main dual band antenna on the roof. High gain.",
        "desc_x30": "My second antenna on the roof.",
        "desc_cg3000": "I use it on 10M-80M bands with a wire wrapped around a fishing rod at my home.",
        "desc_fc50": "Yaesu FT-891's best friend."
      },
      "footer": {
        "followMe": "Follow Me",
        "rightsReserved": "All Rights Reserved."
      },
      "blog": {
        "title": "Blog",
        "noPosts": "No posts yet.",
        "adminTitle": "Admin Panel",
        "postTitle": "Post Title",
        "postContent": "Content",
        "password": "Password",
        "publish": "Publish",
        "success": "Post published successfully!",
        "edit": "Edit",
        "allPosts": "All Posts",
        "newPost": "New Post",
        "delete": "Delete",
        "update": "Update",
        "cancel": "Cancel",
        "confirmDelete": "Are you sure you want to delete this post?",
        "updateSuccess": "Post updated successfully!",
        "deleteSuccess": "Post deleted successfully!",
        "existingPosts": "Existing Posts",
        "passwordPlaceholder": "Enter password to publish/update/delete",
        "passwordRequired": "Password is required for this action.",
        "statsTitle": "Site Statistics",
        "page": "Page",
        "views": "Views",
        "lastVisit": "Last Visit"
      },
      "calculators": {
        "title": "Calculators",
        "gpTitle": "Ground Plane Antenna",
        "frequency": "Frequency (MHz)",
        "calculate": "Calculate",
        "verticalLength": "Radiator Length",
        "radialLength": "Radial Length (each)",
        "efhwTitle": "End-Fed Half Wave (EFHW) Antenna",
        "wireLength": "Radiator Wire Length",
        "counterpoise": "Counterpoise Length (~0.05λ)",
        "dipoleTitle": "Dipole Antenna",
        "totalLength": "Total Length",
        "eachLegLength": "Each Leg Length",
        "cableLossTitle": "Coax Cable Loss",
        "cableType": "Cable Type",
        "cableLength": "Cable Length (m)",
        "lossResult": "Estimated Loss",
        "wavelengthTitle": "Wavelength",
        "fullWave": "Full Wave (1λ)",
        "halfWave": "Half Wave (1/2λ)",
        "quarterWave": "Quarter Wave (1/4λ)",
        "fiveEighthsWave": "5/8 Wave (5/8λ)",
        "velocityFactor": "Velocity Factor (VF)",
        "results": "Results"
      },
      "usefulLinks": {
        "title": "Useful Links",
        "arc": "ARC -Amateur Radio Community",
        "kegm": "KEGM - Coastal Safety (Licensing)",
        "trac": "TRAC - Turkish Radio Amateur Club",
        "iaru": "IARU Region 1"
      },
      "map": {
        "title": "QSO Map",
        "legendTitle": "Band Legend",
        "qsoCount": "QSOs: {{count}}"
      },
      "common": {
        "underConstruction": "{{page}} Page Under Construction..."
      }
    }
  },
  tr: {
    translation: {
      "navbar": {
        "home": "Anasayfa",
        "me": "Ben",
        "about": "Hakkımda",
        "equipment": "İstasyonum",
        "contact": "İletişim",
        "blog": "Blog",
        "map": "QSO Haritası",
        "calculators": "Hesaplayıcılar"
      },
      "about": {
        "title": "Hakkımda",
        "bio1": "Merhaba! Ben Oguz AGCELI. Elektronik ve telsiz haberleşmesine olan ilgim yıllar önce başladı. Babam sayesinde çocukluğum radyolarla ve elektronik devrelerle geçti. İşim yazılım ve elektronik olmasına rağmen lisans almayı hep erteledim. (üşengeçlik kötü :)).",
        "bio2": "HF, VHF ve UHF bantlarında aktif olarak çalışıyorum. Anten deneyleri yapmaktan, dijital modları kullanmaktan ve kendi ekipmanlarımı yapmaktan keyif alıyorum.",
        "bio3": "Aynı zamanda ARC Amatör Radyocular Derneği'nin Ankara temsilciliğini yürütüyorum. Dernek çağrı işaretimiz altında (YM2KTR) 1 DMR geniş alan hotspot, 2 LoRa i-Gate ve 1 AFSK (VHF) APRS istasyonu kurdum / işletiyorum.",
        "certificatesTitle": "Sertifikalar ve Ödüller",
        "cert1": "A Sınıfı Amatör Telsizcilik Belgesi",
        "cert2": "Topluma Hizmet Ödülü"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Amatör Telsiz İstasyonu",
        "description": "TA2GBO (Oğuz AGÇELİ) kişisel amatör telsiz istasyonu. HF/VHF/UHF çalışmaları, anten projeleri, online logbook, QSL kartı oluşturucu ve amatör telsiz hesaplayıcıları (Dipol, EFHW, GP).",
        "keywords": "TA2GBO, Oğuz AGÇELİ, amatör telsiz, ham radio, hf, vhf, uhf, anten projeleri, elektronik, qso logbook, qsl kartı, dmr, aprs, lora, efhw hesaplayıcı, dipol hesaplayıcı, kablo kaybı"
      },
      "home": {
        "welcome": "Merhaba",
        "subtitle": "Amatör Telsizcilik Dünyasına Hoş Geldiniz",
        "logbookBtn": "Logbook'a Göz At",
        "contentTitle": "73!",
        "contentBody1": "TA2GBO çağrı işaretiyle; HF bantlarda SSB ve dijital modlarda aktif olarak çalışıyor, VHF/UHF haberleşme sistemleri üzerine uygulamalar geliştiriyorum. Klasik amatör telsiz çalışmalarının yanı sıra LoRa modülasyonu kullanan deneysel cihaz ve projeler üzerinde çalışıyorum.",
        "contentBody2": "HF ve VHF/UHF bantları için mümkün olduğunca kendi antenlerimi tasarlayıp imal ederek, teoriyi pratikle birleştiren bir yaklaşımı benimsiyorum. Bu site, yürütülen çalışmaların, teknik notların ve saha deneyimlerinin paylaşıldığı kişisel bir arşiv niteliğindedir.",
        "conditions": "Bant ve Atmosfer Durumu",
        "onAirStatus": "Anlık Durum",
        "offAir": "OFF AIR",
        "statsTitle": "Logbook İstatistikleri",
        "statTotal": "Toplam QSO",
        "statYear": "Bu Yıl",
        "statToday": "Bugün",
        "statMonth": "Bu Ay",
        "qslSearchTitle": "Sizinle daha önce QSO yaptık mı? Eğer öyleyse hemen Dijital QSL Kartınızı alın !",
        "callsignPlaceholder": "Çağrı İşareti Girin",
        "searchBtn": "Sorgula",
        "qslSearchNoResult": "Üzgünüm hiç QSO yapmamışız",
        "qslSearchResults": "Bulunan Kayıtlar:",
        "downloadQsl": "QSL Kartı İndir",
        "qslPreview": "QSL Kartı Önizleme",
        "close": "Kapat",
        "lastQSOs": "Son 10 Görüşme",
        "date": "Tarih",
        "time": "Saat",
        "callsign": "Çağrı İşareti",
        "band": "Bant",
        "grid": "Grid",
        "mode": "Mod",
        "rst": "RST"
      },
      "contact": {
        "title": "İletişim",
        "email": "E-posta",
        "instagram": "Instagram",
        "qrz": "QRZ.com Profili",
        "grid": "Grid Locator",
        "youtube": "YouTube "
      },
      "station": {
        "radios": "Telsizler",
        "antennas": "Antenler",
        "accessories": "Tunerler, Aksesuarlar ve Diğer Ekipmanlar",
        "desc_ft710": "Ana HF telsizim. Genellikle dijital modlarda ve SSB görüşmelerinde kullanıyorum.",
        "desc_ft891": "İkinici / Saha telsizim. Aktivitelerde ya da arabamda kullanıyorum.",
        "desc_d878uv": "DMR ve analog yerel görüşmeler için kullandığım el telsizi.",
        "desc_uvk6": "Saha çalışmaları ve yedek kullanım için.",
        "desc_atas120a": "Arabamda ya da sahada mobil operasyonlar için.",
        "desc_efhw": "40m-10m arası bantlarda çalışan, kendi yapımım tel anten.",
        "desc_vx50": "Çatıdaki ana dual band antenim. Yüksek kazançlı.",
        "desc_x30": "Çatıdaki ikinci antenim",
        "desc_cg3000": "Evimde bir balık oltasına sardığım tel ile 10M-80M bantlarında kullanıyorum.",
        "desc_fc50": "Yaesu FT-891'in en iyi arkadaşı"
      },
      "footer": {
        "followMe": "Beni Takip Edin",
        "rightsReserved": "Tüm Hakları Saklıdır."
      },
      "blog": {
        "title": "Blog",
        "noPosts": "Henüz yazı yok.",
        "adminTitle": "Yönetici Paneli",
        "postTitle": "Yazı Başlığı",
        "postContent": "İçerik",
        "password": "Şifre",
        "publish": "Yayınla",
        "success": "Yazı başarıyla yayınlandı!",
        "edit": "Düzenle",
        "allPosts": "Tüm Yazılar",
        "newPost": "Yeni Yazı",
        "delete": "Sil",
        "update": "Güncelle",
        "cancel": "İptal",
        "confirmDelete": "Bu yazıyı silmek istediğinize emin misiniz?",
        "updateSuccess": "Yazı başarıyla güncellendi!",
        "deleteSuccess": "Yazı başarıyla silindi!",
        "existingPosts": "Mevcut Yazılar",
        "passwordPlaceholder": "Yayınlamak/Güncellemek/Silmek için şifre girin",
        "passwordRequired": "Bu işlem için şifre gereklidir.",
        "statsTitle": "Site İstatistikleri",
        "page": "Sayfa",
        "views": "Görüntüleme",
        "lastVisit": "Son Ziyaret"
      },
      "calculators": {
        "title": "Hesaplayıcılar",
        "gpTitle": "Ground Plane Anten",
        "frequency": "Frekans (MHz)",
        "calculate": "Hesapla",
        "verticalLength": "Canlı Uç Boyu (Radyatör)",
        "radialLength": "Radial Boyu (Her biri)",
        "efhwTitle": "End-Fed Half Wave (EFHW) Anten",
        "wireLength": "Radyatör Tel Boyu",
        "counterpoise": "Karşıt Ağırlık (Counterpoise) Boyu (~0.05λ)",
        "dipoleTitle": "Dipol Anten",
        "totalLength": "Toplam Uzunluk",
        "eachLegLength": "Her Bir Kolun Uzunluğu",
        "cableLossTitle": "Koaksiyel Kablo Kaybı",
        "cableType": "Kablo Tipi",
        "cableLength": "Kablo Uzunluğu (m)",
        "lossResult": "Tahmini Kayıp",
        "wavelengthTitle": "Dalga Boyu",
        "fullWave": "Tam Dalga (1λ)",
        "halfWave": "Yarım Dalga (1/2λ)",
        "quarterWave": "Çeyrek Dalga (1/4λ)",
        "fiveEighthsWave": "5/8 Dalga (5/8λ)",
        "velocityFactor": "Hız Faktörü (VF)",
        "results": "Sonuçlar"
      },
      "usefulLinks": {
        "title": "Faydalı Linkler",
        "arc": "ARC - Amatör Radyocular Derneği",
        "kegm": "KEGM - Kıyı Emniyeti (Sınav/Belge)",
        "trac": "TRAC - Türkiye Radyo Amatörleri Cemiyeti",
        "iaru": "IARU 1. Bölge"
      },
      "map": {
        "title": "QSO Haritası",
        "legendTitle": "Bant Renkleri",
        "qsoCount": "QSO Sayısı: {{count}}"
      },
      "common": {
        "underConstruction": "{{page}} Sayfası Yapım Aşamasında..."
      }
    }
  },
  de: {
    translation: {
      "navbar": {
        "home": "Startseite",
        "me": "Ich",
        "about": "Über Mich",
        "equipment": "Meine Station",
        "contact": "Kontakt",
        "blog": "Blog",
        "map": "QSO-Karte",
        "calculators": "Rechner"
      },
      "about": {
        "title": "Über Mich",
        "bio1": "Hallo! Ich bin Oguz AGCELI. Mein Interesse an Elektronik und Funkkommunikation begann vor Jahren. Dank meines Vaters verbrachte ich meine Kindheit mit Radios und elektronischen Schaltungen. Obwohl mein Beruf Software und Elektronik ist, habe ich es immer aufgeschoben, eine Lizenz zu erwerben (Aufschieben ist schlecht :)).",
        "bio2": "Ich bin aktiv auf HF-, VHF- und UHF-Bändern. Ich experimentiere gerne mit Antennen, nutze digitale Modi und baue meine eigene Ausrüstung.",
        "bio3": "Außerdem bin ich der Ankara-Vertreter der ARC Amateur Radio Operators Association. Unter unserem Club-Rufzeichen (YM2KTR) habe ich 1 DMR-Weitbereichs-Hotspot, 2 LoRa i-Gates und 1 AFSK (VHF) APRS-Station eingerichtet / betreibe diese.",
        "certificatesTitle": "Zertifikate und Auszeichnungen",
        "cert1": "Amateurfunklizenz Klasse A",
        "cert2": "Auszeichnung für gemeinnützige Arbeit"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Amateurfunkstation",
        "description": "Persönliche Amateurfunkstation von TA2GBO (Oguz AGCELI). Entdecken Sie HF/VHF/UHF-Aktivitäten, Antennenprojekte, Online-Logbuch, QSL-Kartengenerator und Amateurfunkrechner.",
        "keywords": "TA2GBO, Oguz AGCELI, amateurfunk, ham radio, hf, vhf, uhf, antennenprojekte, elektronik, qso logbuch, qsl karte, dmr, aprs, lora, efhw rechner, dipol rechner"
      },
      "home": {
        "welcome": "Hallo",
        "subtitle": "Willkommen in der Welt des Amateurfunks",
        "logbookBtn": "Logbuch ansehen",
        "contentTitle": "73!",
        "contentBody1": "Mit dem Rufzeichen TA2GBO arbeite ich aktiv auf HF-Bändern in SSB- und Digitalmodi und entwickle Anwendungen für VHF/UHF-Kommunikationssysteme. Neben klassischen Amateurfunkarbeiten beschäftige ich mich mit experimentellen Geräten und Projekten, die LoRa-Modulation verwenden.",
        "contentBody2": "Ich verfolge einen Ansatz, der Theorie und Praxis verbindet, indem ich meine eigenen Antennen für HF- und VHF/UHF-Bänder so weit wie möglich selbst entwerfe und herstelle. Diese Seite ist ein persönliches Archiv, in dem durchgeführte Arbeiten, technische Notizen und Erfahrungen aus dem Feld geteilt werden.",
        "conditions": "Bandbedingungen",
        "onAirStatus": "Aktueller Status",
        "offAir": "OFF AIR",
        "statsTitle": "Logbuch-Statistiken",
        "statTotal": "Gesamt QSOs",
        "statYear": "Dieses Jahr",
        "statToday": "Heute",
        "statMonth": "Diesen Monat",
        "qslSearchTitle": "Hatten wir schon ein QSO? Wenn ja, holen Sie sich jetzt Ihre digitale QSL-Karte!",
        "callsignPlaceholder": "Rufzeichen eingeben",
        "searchBtn": "Suchen",
        "qslSearchNoResult": "Leider haben wir kein QSO gehabt.",
        "qslSearchResults": "Gefundene QSOs:",
        "downloadQsl": "QSL-Karte herunterladen",
        "qslPreview": "QSL-Karte Vorschau",
        "close": "Schließen",
        "lastQSOs": "Letzte 10 QSOs",
        "date": "Datum",
        "time": "Zeit",
        "callsign": "Rufzeichen",
        "band": "Band",
        "grid": "Locator",
        "mode": "Modus",
        "rst": "RST"
      },
      "contact": {
        "title": "Kontakt",
        "email": "E-Mail",
        "instagram": "Instagram",
        "qrz": "QRZ.com Profil",
        "grid": "Grid Locator",
        "youtube": "YouTube "
      },
      "station": {
        "radios": "Funkgeräte",
        "antennas": "Antennen",
        "accessories": "Zubehör & Sonstiges",
        "desc_ft710": "Mein Haupt-HF-Transceiver. Ich benutze ihn hauptsächlich für digitale Betriebsarten und SSB-Gespräche.",
        "desc_ft891": "Mein Zweit-/Feldgerät. Ich benutze es bei Aktivitäten oder in meinem Auto.",
        "desc_d878uv": "Handfunkgerät, das ich für DMR und analoge lokale Gespräche verwende.",
        "desc_uvk6": "Für Feldarbeiten und als Ersatzgerät.",
        "desc_atas120a": "Für den mobilen Einsatz im Auto oder im Feld.",
        "desc_efhw": "Selbstgebaute Drahtantenne, die auf den Bändern zwischen 40m-10m arbeitet.",
        "desc_vx50": "Meine Haupt-Dualband-Antenne auf dem Dach. Hoher Gewinn.",
        "desc_x30": "Meine zweite Antenne auf dem Dach.",
        "desc_cg3000": "Ich benutze sie auf den 10M-80M Bändern mit einem Draht, der um eine Angelrute gewickelt ist, bei mir zu Hause.",
        "desc_fc50": "Der beste Freund des Yaesu FT-891."
      },
      "footer": {
        "followMe": "Folgen Sie mir",
        "rightsReserved": "Alle Rechte vorbehalten."
      },
      "blog": {
        "title": "Blog",
        "noPosts": "Noch keine Beiträge.",
        "adminTitle": "Admin-Bereich",
        "postTitle": "Titel",
        "postContent": "Inhalt",
        "password": "Passwort",
        "publish": "Veröffentlichen",
        "success": "Beitrag erfolgreich veröffentlicht!",
        "edit": "Bearbeiten",
        "allPosts": "Alle Beiträge",
        "newPost": "Neuer Beitrag",
        "delete": "Löschen",
        "update": "Aktualisieren",
        "cancel": "Abbrechen",
        "confirmDelete": "Sind Sie sicher, dass Sie diesen Beitrag löschen möchten?",
        "updateSuccess": "Beitrag erfolgreich aktualisiert!",
        "deleteSuccess": "Beitrag erfolgreich gelöscht!",
        "existingPosts": "Vorhandene Beiträge",
        "passwordPlaceholder": "Passwort eingeben",
        "passwordRequired": "Passwort ist erforderlich.",
        "statsTitle": "Seitenstatistiken",
        "page": "Seite",
        "views": "Ansichten",
        "lastVisit": "Letzter Besuch"
      },
      "calculators": {
        "title": "Rechner",
        "gpTitle": "Ground Plane Antenne",
        "frequency": "Frequenz (MHz)",
        "calculate": "Berechnen",
        "verticalLength": "Strahlerlänge",
        "radialLength": "Radial Länge (jeweils)",
        "efhwTitle": "End-Fed Half Wave (EFHW) Antenne",
        "wireLength": "Strahlerdrahtlänge",
        "counterpoise": "Gegengewichtslänge (~0.05λ)",
        "dipoleTitle": "Dipol-Antenne",
        "totalLength": "Gesamtlänge",
        "eachLegLength": "Länge jedes Schenkels",
        "cableLossTitle": "Koaxialkabel-Verlust",
        "cableType": "Kabeltyp",
        "cableLength": "Kabellänge (m)",
        "lossResult": "Geschätzter Verlust",
        "wavelengthTitle": "Wellenlänge",
        "fullWave": "Vollwelle (1λ)",
        "halfWave": "Halbwelle (1/2λ)",
        "quarterWave": "Viertelwelle (1/4λ)",
        "fiveEighthsWave": "5/8 Welle (5/8λ)",
        "velocityFactor": "Verkürzungsfaktor (VF)",
        "results": "Ergebnisse"
      },
      "usefulLinks": {
        "title": "Nützliche Links",
        "arc": "ARC - Amateurfunk-Gemeinschaft",
        "kegm": "KEGM - Küstensicherheit",
        "trac": "TRAC - Türkischer Funkamateurverband",
        "iaru": "IARU Region 1"
      },
      "map": {
        "title": "QSO-Karte",
        "legendTitle": "Bandlegende",
        "qsoCount": "QSOs: {{count}}"
      },
      "common": {
        "underConstruction": "{{page}} Seite im Aufbau..."
      }
    }
  },
  es: {
    translation: {
      "navbar": {
        "home": "Inicio",
        "me": "Yo",
        "about": "Sobre Mí",
        "equipment": "Mi Estación",
        "contact": "Contacto",
        "blog": "Blog",
        "map": "Mapa de QSO",
        "calculators": "Calculadoras"
      },
      "about": {
        "title": "Sobre Mí",
        "bio1": "¡Hola! Soy Oguz AGCELI. Mi interés por la electrónica y la comunicación por radio comenzó hace años. Gracias a mi padre, mi infancia la pasé con radios y circuitos electrónicos. Aunque mi trabajo es software y electrónica, siempre pospuse la obtención de una licencia (la procrastinación es mala :)).",
        "bio2": "Opero activamente en bandas HF, VHF y UHF. Disfruto experimentando con antenas, usando modos digitales y construyendo mi propio equipo.",
        "bio3": "También soy el representante en Ankara de la Asociación de Operadores de Radioaficionados ARC. Bajo nuestro indicativo de club (YM2KTR), he instalado / estoy operando 1 hotspot DMR de área amplia, 2 i-Gates LoRa y 1 estación APRS AFSK (VHF).",
        "certificatesTitle": "Certificados y Premios",
        "cert1": "Licencia de Radioaficionado Clase A",
        "cert2": "Premio al Servicio Comunitario"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Estación de Radioaficionado",
        "description": "Estación de radioaficionado personal de TA2GBO (Oguz AGCELI). Explore actividades HF/VHF/UHF, proyectos de antenas, libro de guardia en línea, generador de tarjetas QSL y calculadoras.",
        "keywords": "TA2GBO, Oguz AGCELI, radioafición, ham radio, hf, vhf, uhf, proyectos de antenas, electrónica, qso logbook, tarjeta qsl, dmr, aprs, lora, calculadora efhw, calculadora dipolo"
      },
      "home": {
        "welcome": "Hola",
        "subtitle": "Bienvenido al Mundo de la Radioafición",
        "logbookBtn": "Ver Libro de Guardia",
        "contentTitle": "73!",
        "contentBody1": "Con el indicativo TA2GBO; trabajo activamente en bandas HF en modos SSB y digitales, y desarrollo aplicaciones sobre sistemas de comunicación VHF/UHF. Además de los trabajos clásicos de radioaficionado, trabajo en dispositivos y proyectos experimentales que utilizan modulación LoRa.",
        "contentBody2": "Adopto un enfoque que combina la teoría con la práctica diseñando y fabricando mis propias antenas para bandas HF y VHF/UHF tanto como sea posible. Este sitio es un archivo personal donde se comparten los trabajos realizados, notas técnicas y experiencias de campo.",
        "conditions": "Condiciones de Banda",
        "onAirStatus": "Estado Actual",
        "offAir": "OFF AIR",
        "statsTitle": "Estadísticas del Libro",
        "statTotal": "Total QSOs",
        "statYear": "Este Año",
        "statToday": "Hoy",
        "statMonth": "Este Mes",
        "qslSearchTitle": "¿Tuvimos un QSO antes? Si es así, ¡obtenga su tarjeta QSL digital ahora!",
        "callsignPlaceholder": "Ingrese Indicativo",
        "searchBtn": "Buscar",
        "qslSearchNoResult": "Lo siento, no hemos tenido un QSO.",
        "qslSearchResults": "QSOs Encontrados:",
        "downloadQsl": "Descargar Tarjeta QSL",
        "qslPreview": "Vista previa de la tarjeta QSL",
        "close": "Cerrar",
        "lastQSOs": "Últimos 10 QSOs",
        "date": "Fecha",
        "time": "Hora",
        "callsign": "Indicativo",
        "band": "Banda",
        "grid": "Grid",
        "mode": "Modo",
        "rst": "RST"
      },
      "contact": {
        "title": "Contacto",
        "email": "Correo Electrónico",
        "instagram": "Instagram",
        "qrz": "Perfil de QRZ.com",
        "grid": "Grid Locator",
        "youtube": "YouTube "
      },
      "station": {
        "radios": "Transceptores",
        "antennas": "Antenas",
        "accessories": "Accesorios y Otros Equipos",
        "desc_ft710": "Mi transceptor HF principal. Generalmente lo uso para modos digitales y contactos SSB.",
        "desc_ft891": "Mi segunda radio / radio de campo. La uso en actividades o en mi coche.",
        "desc_d878uv": "Radio portátil que uso para comunicaciones locales DMR y analógicas.",
        "desc_uvk6": "Para trabajo de campo y uso de respaldo.",
        "desc_atas120a": "Para operaciones móviles en mi coche o en el campo.",
        "desc_efhw": "Antena de hilo de fabricación propia que funciona en bandas entre 40m-10m.",
        "desc_vx50": "Mi antena principal de doble banda en el techo. Alta ganancia.",
        "desc_x30": "Mi segunda antena en el techo.",
        "desc_cg3000": "Lo uso en bandas de 10M-80M con un cable enrollado alrededor de una caña de pescar en mi casa.",
        "desc_fc50": "El mejor amigo del Yaesu FT-891."
      },
      "footer": {
        "followMe": "Sígueme",
        "rightsReserved": "Todos los derechos reservados."
      },
      "blog": {
        "title": "Blog",
        "noPosts": "Aún no hay publicaciones.",
        "adminTitle": "Panel de Administración",
        "postTitle": "Título",
        "postContent": "Contenido",
        "password": "Contraseña",
        "publish": "Publicar",
        "success": "¡Publicación exitosa!",
        "edit": "Editar",
        "allPosts": "Todas las publicaciones",
        "newPost": "Nueva publicación",
        "delete": "Eliminar",
        "update": "Actualizar",
        "cancel": "Cancelar",
        "confirmDelete": "¿Estás seguro de que quieres eliminar esta publicación?",
        "updateSuccess": "¡Publicación actualizada con éxito!",
        "deleteSuccess": "¡Publicación eliminada con éxito!",
        "existingPosts": "Publicaciones Existentes",
        "passwordPlaceholder": "Ingrese contraseña",
        "passwordRequired": "Se requiere contraseña.",
        "statsTitle": "Estadísticas del sitio",
        "page": "Página",
        "views": "Vistas",
        "lastVisit": "Última visita"
      },
      "calculators": {
        "title": "Calculadoras",
        "gpTitle": "Antena Ground Plane",
        "frequency": "Frecuencia (MHz)",
        "calculate": "Calcular",
        "verticalLength": "Longitud del Radiador",
        "radialLength": "Longitud del Radial (cada uno)",
        "efhwTitle": "Antena EFHW",
        "wireLength": "Longitud del Cable Radiante",
        "counterpoise": "Longitud del Contrapeso (~0.05λ)",
        "dipoleTitle": "Antena Dipolo",
        "totalLength": "Longitud Total",
        "eachLegLength": "Longitud de Cada Brazo",
        "cableLossTitle": "Pérdida de Cable Coaxial",
        "cableType": "Tipo de Cable",
        "cableLength": "Longitud del Cable (m)",
        "lossResult": "Pérdida Estimada",
        "wavelengthTitle": "Longitud de Onda",
        "fullWave": "Onda Completa (1λ)",
        "halfWave": "Media Onda (1/2λ)",
        "quarterWave": "Cuarto de Onda (1/4λ)",
        "fiveEighthsWave": "5/8 de Onda (5/8λ)",
        "velocityFactor": "Factor de Velocidad (VF)",
        "results": "Resultados"
      },
      "usefulLinks": {
        "title": "Enlaces Útiles",
        "arc": "ARC - Comunidad de Radioaficionados",
        "kegm": "KEGM - Seguridad Costera",
        "trac": "TRAC - Club de Radioaficionados Turcos",
        "iaru": "IARU Región 1"
      },
      "map": {
        "title": "Mapa de QSO",
        "legendTitle": "Leyenda de Bandas",
        "qsoCount": "QSOs: {{count}}"
      },
      "common": {
        "underConstruction": "Página de {{page}} en Construcción..."
      }
    }
  },
  fr: {
    translation: {
      "navbar": {
        "home": "Accueil",
        "me": "Moi",
        "about": "À propos",
        "equipment": "Ma Station",
        "contact": "Contact",
        "blog": "Blog",
        "map": "Carte QSO",
        "calculators": "Calculateurs"
      },
      "about": {
        "title": "À propos de moi",
        "bio1": "Bonjour ! Je suis Oguz AGCELI. Mon intérêt pour l'électronique et la communication radio a commencé il y a des années. Grâce à mon père, mon enfance s'est passée avec des radios et des circuits électroniques. Bien que mon travail soit le logiciel et l'électronique, j'ai toujours reporté l'obtention d'une licence (la procrastination, c'est mal :)).",
        "bio2": "J'opère activement sur les bandes HF, VHF et UHF. J'aime expérimenter avec les antennes, utiliser les modes numériques et construire mon propre équipement.",
        "bio3": "Je suis également le représentant d'Ankara de l'Association des Opérateurs Radioamateurs ARC. Sous notre indicatif de club (YM2KTR), j'ai installé / j'exploite 1 hotspot DMR à large zone, 2 i-Gates LoRa et 1 station APRS AFSK (VHF).",
        "certificatesTitle": "Certificats et Récompenses",
        "cert1": "Licence Radioamateur Classe A",
        "cert2": "Prix du Service Communautaire"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Station Radioamateur",
        "description": "Station radioamateur personnelle de TA2GBO (Oguz AGCELI). Découvrez les activités HF/VHF/UHF, les projets d'antennes, le journal de bord en ligne, le générateur de cartes QSL et les calculateurs.",
        "keywords": "TA2GBO, Oguz AGCELI, radioamateur, ham radio, hf, vhf, uhf, projets d'antennes, électronique, qso logbook, carte qsl, dmr, aprs, lora, calculateur efhw, calculateur dipôle"
      },
      "home": {
        "welcome": "Bonjour",
        "subtitle": "Bienvenue dans le monde de la radioamateur",
        "logbookBtn": "Voir le journal de bord",
        "contentTitle": "73!",
        "contentBody1": "Avec l'indicatif TA2GBO; je travaille activement sur les bandes HF en SSB et en modes numériques, et je développe des applications sur les systèmes de communication VHF/UHF. En plus du travail radioamateur classique, je travaille sur des appareils et projets expérimentaux utilisant la modulation LoRa.",
        "contentBody2": "J'adopte une approche qui combine la théorie et la pratique en concevant et fabriquant mes propres antennes pour les bandes HF et VHF/UHF autant que possible. Ce site est une archive personnelle où sont partagés les travaux réalisés, les notes techniques et les expériences de terrain.",
        "conditions": "Conditions de bande",
        "onAirStatus": "Statut Actuel",
        "offAir": "OFF AIR",
        "statsTitle": "Statistiques du journal",
        "statTotal": "QSO totaux",
        "statYear": "Cette année",
        "statToday": "Aujourd'hui",
        "statMonth": "Ce mois-ci",
        "qslSearchTitle": "Avons-nous déjà eu un QSO ? Si oui, obtenez votre carte QSL numérique maintenant !",
        "callsignPlaceholder": "Entrez l'indicatif",
        "searchBtn": "Rechercher",
        "qslSearchNoResult": "Désolé, nous n'avons pas eu de QSO.",
        "qslSearchResults": "QSO trouvés :",
        "downloadQsl": "Télécharger la carte QSL",
        "qslPreview": "Aperçu de la QSL",
        "close": "Fermer",
        "lastQSOs": "10 derniers QSO",
        "date": "Date",
        "time": "Heure",
        "callsign": "Indicatif",
        "band": "Bande",
        "grid": "Grid",
        "mode": "Mode",
        "rst": "RST"
      },
      "contact": {
        "title": "Contact",
        "email": "E-mail",
        "instagram": "Instagram",
        "qrz": "Profil QRZ.com",
        "grid": "Grid Locator",
        "youtube": "YouTube"
      },
      "station": {
        "radios": "Transceivers",
        "antennas": "Antennes",
        "accessories": "Accessoires et autres",
        "desc_ft710": "Mon transceiver HF principal. Je l'utilise généralement pour les modes numériques et les contacts SSB.",
        "desc_ft891": "Ma deuxième radio / radio de terrain. Je l'utilise lors d'activités ou dans ma voiture.",
        "desc_d878uv": "Radio portable que j'utilise pour les communications locales DMR et analogiques.",
        "desc_uvk6": "Pour le travail sur le terrain et comme radio de secours.",
        "desc_atas120a": "Pour les opérations mobiles dans ma voiture ou sur le terrain.",
        "desc_efhw": "Antenne filaire de ma fabrication fonctionnant sur les bandes de 40m à 10m.",
        "desc_vx50": "Mon antenne bibande principale sur le toit. Gain élevé.",
        "desc_x30": "Ma deuxième antenne sur le toit.",
        "desc_cg3000": "Je l'utilise sur les bandes 10M-80M avec un fil enroulé autour d'une canne à pêche à la maison.",
        "desc_fc50": "Le meilleur ami du Yaesu FT-891."
      },
      "footer": {
        "followMe": "Suivez-moi",
        "rightsReserved": "Tous droits réservés."
      },
      "blog": {
        "title": "Blog",
        "noPosts": "Aucun article pour le moment.",
        "adminTitle": "Panneau d'administration",
        "postTitle": "Titre de l'article",
        "postContent": "Contenu",
        "password": "Mot de passe",
        "publish": "Publier",
        "success": "Article publié avec succès !",
        "edit": "Modifier",
        "allPosts": "Tous les articles",
        "newPost": "Nouvel article",
        "delete": "Supprimer",
        "update": "Mettre à jour",
        "cancel": "Annuler",
        "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet article ?",
        "updateSuccess": "Article mis à jour avec succès !",
        "deleteSuccess": "Article supprimé avec succès !",
        "existingPosts": "Articles existants",
        "passwordPlaceholder": "Entrez le mot de passe pour publier/mettre à jour/supprimer",
        "passwordRequired": "Un mot de passe est requis pour cette action.",
        "statsTitle": "Statistiques du site",
        "page": "Page",
        "views": "Vues",
        "lastVisit": "Dernière visite"
      },
      "calculators": {
        "title": "Calculateurs",
        "gpTitle": "Antenne Ground Plane",
        "frequency": "Fréquence (MHz)",
        "calculate": "Calculer",
        "verticalLength": "Longueur du radiateur",
        "radialLength": "Longueur du radial (chacun)",
        "efhwTitle": "Antenne End-Fed Half Wave (EFHW)",
        "wireLength": "Longueur du fil radiateur",
        "counterpoise": "Longueur du contrepoids (~0.05λ)",
        "dipoleTitle": "Antenne dipôle",
        "totalLength": "Longueur totale",
        "eachLegLength": "Longueur de chaque brin",
        "cableLossTitle": "Perte de câble coaxial",
        "cableType": "Type de câble",
        "cableLength": "Longueur du câble (m)",
        "lossResult": "Perte estimée",
        "wavelengthTitle": "Longueur d'onde",
        "fullWave": "Onde complète (1λ)",
        "halfWave": "Demi-onde (1/2λ)",
        "quarterWave": "Quart d'onde (1/4λ)",
        "fiveEighthsWave": "5/8 d'onde (5/8λ)",
        "velocityFactor": "Facteur de vélocité (VF)",
        "results": "Résultats"
      },
      "usefulLinks": {
        "title": "Liens utiles",
        "arc": "ARC - Communauté des Radioamateurs",
        "kegm": "KEGM - Sécurité Côtière (Licences)",
        "trac": "TRAC - Club des Radioamateurs de Turquie",
        "iaru": "IARU Région 1"
      },
      "map": {
        "title": "Carte QSO",
        "legendTitle": "Légende des Bandes",
        "qsoCount": "QSOs: {{count}}"
      },
      "common": {
        "underConstruction": "Page {{page}} en construction..."
      }
    }
  },
  ru: {
    translation: {
      "navbar": {
        "home": "Главная",
        "me": "Я",
        "about": "Обо мне",
        "equipment": "Моя станция",
        "contact": "Контакт",
        "blog": "Блог",
        "map": "Карта QSO",
        "calculators": "Калькуляторы"
      },
      "about": {
        "title": "Обо мне",
        "bio1": "Привет! Я Огуз АГДЖЕЛИ. Мой интерес к электронике и радиосвязи начался много лет назад. Благодаря моему отцу, мое детство прошло с радиоприемниками и электронными схемами. Хотя моя работа связана с программным обеспечением и электроникой, я всегда откладывал получение лицензии (прокрастинация - это плохо :)).",
        "bio2": "Я активно работаю на КВ, УКВ и ДЦВ диапазонах. Мне нравится экспериментировать с антеннами, использовать цифровые виды связи и создавать собственное оборудование.",
        "bio3": "Я также являюсь представителем Ассоциации радиолюбителей ARC в Анкаре. Под позывным нашего клуба (YM2KTR) я установил / эксплуатирую 1 широкополосный хот-спот DMR, 2 i-Gate LoRa и 1 станцию APRS AFSK (VHF).",
        "certificatesTitle": "Сертификаты и награды",
        "cert1": "Радиолюбительская лицензия класса A",
        "cert2": "Награда за общественную деятельность"
      },
      "meta": {
        "defaultTitle": "TA2GBO - Радиолюбительская станция",
        "description": "Персональная радиолюбительская станция TA2GBO (Огуз АГДЖЕЛИ). Активность на КВ/УКВ/ДЦВ, антенные проекты, онлайн-журнал, генератор QSL-карт и калькуляторы.",
        "keywords": "TA2GBO, Огуз АГДЖЕЛИ, радиолюбитель, ham radio, кв, укв, дцв, антенные проекты, электроника, qso журнал, qsl карточка, dmr, aprs, lora, калькулятор efhw, калькулятор диполя"
      },
      "home": {
        "welcome": "Привет",
        "subtitle": "Добро пожаловать в мир радиолюбительства",
        "logbookBtn": "Посмотреть журнал",
        "contentTitle": "73!",
        "contentBody1": "С позывным TA2GBO; я активно работаю на КВ диапазонах в SSB и цифровых режимах, а также разрабатываю приложения для систем связи УКВ/ДЦВ. Помимо классической радиолюбительской работы, я занимаюсь экспериментальными устройствами и проектами, использующими модуляцию LoRa.",
        "contentBody2": "Я придерживаюсь подхода, сочетающего теорию с практикой, проектируя и изготавливая собственные антенны для КВ и УКВ/ДЦВ диапазонов. Этот сайт является личным архивом, где делюсь выполненными работами, техническими заметками и полевым опытом.",
        "conditions": "Состояние диапазонов",
        "onAirStatus": "Текущий статус",
        "offAir": "OFF AIR",
        "statsTitle": "Статистика журнала",
        "statTotal": "Всего QSO",
        "statYear": "В этом году",
        "statToday": "Сегодня",
        "statMonth": "В этом месяце",
        "qslSearchTitle": "У нас было QSO раньше? Если да, получите свою цифровую QSL-карточку сейчас!",
        "callsignPlaceholder": "Введите позывной",
        "searchBtn": "Поиск",
        "qslSearchNoResult": "К сожалению, у нас не было QSO.",
        "qslSearchResults": "Найденные QSO:",
        "downloadQsl": "Скачать QSL-карточку",
        "qslPreview": "Предпросмотр QSL",
        "close": "Закрыть",
        "lastQSOs": "Последние 10 QSO",
        "date": "Дата",
        "time": "Время",
        "callsign": "Позывной",
        "band": "Диапазон",
        "grid": "Квадрат",
        "mode": "Модуляция",
        "rst": "RST"
      },
      "contact": {
        "title": "Контакт",
        "email": "Эл. почта",
        "instagram": "Instagram",
        "qrz": "Профиль на QRZ.com",
        "grid": "Grid локатор",
        "youtube": "YouTube"
      },
      "station": {
        "radios": "Трансиверы",
        "antennas": "Антенны",
        "accessories": "Аксессуары и другое",
        "desc_ft710": "Мой основной КВ трансивер. В основном использую для цифровых режимов и SSB.",
        "desc_ft891": "Мой второй / полевой трансивер. Использую в поездках или в машине.",
        "desc_d878uv": "Портативная радиостанция для DMR и аналоговой местной связи.",
        "desc_uvk6": "Для полевой работы и как резервная.",
        "desc_atas120a": "Для мобильных операций в машине или в поле.",
        "desc_efhw": "Самодельная проволочная антенна, работающая на диапазонах 40-10м.",
        "desc_vx50": "Моя основная двухдиапазонная антенна на крыше. С высоким усилением.",
        "desc_x30": "Моя вторая антенна на крыше.",
        "desc_cg3000": "Использую на диапазонах 10-80м с проводом, намотанным на удочку.",
        "desc_fc50": "Лучший друг Yaesu FT-891."
      },
      "footer": {
        "followMe": "Следите за мной",
        "rightsReserved": "Все права защищены."
      },
      "blog": {
        "title": "Блог",
        "noPosts": "Записей пока нет.",
        "adminTitle": "Панель администратора",
        "postTitle": "Заголовок записи",
        "postContent": "Содержание",
        "password": "Пароль",
        "publish": "Опубликовать",
        "success": "Запись успешно опубликована!",
        "edit": "Редактировать",
        "allPosts": "Все записи",
        "newPost": "Новая запись",
        "delete": "Удалить",
        "update": "Обновить",
        "cancel": "Отмена",
        "confirmDelete": "Вы уверены, что хотите удалить эту запись?",
        "updateSuccess": "Запись успешно обновлена!",
        "deleteSuccess": "Запись успешно удалена!",
        "existingPosts": "Существующие записи",
        "passwordPlaceholder": "Введите пароль для публикации/обновления/удаления",
        "passwordRequired": "Для этого действия требуется пароль.",
        "statsTitle": "Статистика сайта",
        "page": "Страница",
        "views": "Просмотры",
        "lastVisit": "Последний визит"
      },
      "calculators": {
        "title": "Калькуляторы",
        "gpTitle": "Антенна Ground Plane",
        "frequency": "Частота (МГц)",
        "calculate": "Рассчитать",
        "verticalLength": "Длина излучателя",
        "radialLength": "Длина радиала (каждый)",
        "efhwTitle": "Антенна End-Fed Half Wave (EFHW)",
        "wireLength": "Длина провода излучателя",
        "counterpoise": "Длина противовеса (~0.05λ)",
        "dipoleTitle": "Дипольная антенна",
        "totalLength": "Общая длина",
        "eachLegLength": "Длина каждого плеча",
        "cableLossTitle": "Потери в коаксиальном кабеле",
        "cableType": "Тип кабеля",
        "cableLength": "Длина кабеля (м)",
        "lossResult": "Примерные потери",
        "wavelengthTitle": "Длина волны",
        "fullWave": "Полная волна (1λ)",
        "halfWave": "Полуволна (1/2λ)",
        "quarterWave": "Четверть волны (1/4λ)",
        "fiveEighthsWave": "5/8 волны (5/8λ)",
        "velocityFactor": "Коэффициент укорочения (VF)",
        "results": "Результаты"
      },
      "usefulLinks": {
        "title": "Полезные ссылки",
        "arc": "ARC - Сообщество радиолюбителей",
        "kegm": "KEGM - Береговая охрана (Лицензирование)",
        "trac": "TRAC - Турецкий радиолюбительский клуб",
        "iaru": "IARU Регион 1"
      },
      "map": {
        "title": "Карта QSO",
        "legendTitle": "Легенда диапазонов",
        "qsoCount": "QSOs: {{count}}"
      },
      "common": {
        "underConstruction": "Страница {{page}} в разработке..."
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;